import React from "react";

export default function HamburgerMenu({ isOpen, onClick }) {
    console.log("Hamburger rendered. isOpen =", isOpen);
    return (
        <button className="hamburger-menu" onClick={() => {
            console.log("Hamburger clicked");
            onClick(); // This should toggle isMenuOpen
        }}>
            {isOpen ? "✕" : "☰"}
        </button>
    );
}
